// extracted by mini-css-extract-plugin
export var outlinedCard = "_redotech-redo-customer-portal-app-src-portal-four-returns-confirmation-outlined-card";